export default {
	IDM_CLIENT_ID: 'shouldHaveMockedThis.com',
	ID_GATEWAY_URL: 'shouldHaveMockedThis.com',
	ORG_SERVICE_URL: 'shouldHaveMockedThis.com',
};
